import React, { Component } from 'react'
import onlyLoggedIn from './onlyLoggedIn'
import Home from './Home'

let Likes = () => <Home videos_url={`/api/get_likes`} not_found_msg={"You haven't Liked any videos yet. Click the Heart Icon below a video to Like it."} />


export default onlyLoggedIn(Likes)